export default function Image({src, alt}){

    return (
        <div className="entry-image">
            <img src={src} alt={alt}></img>
        </div>
    );
}